// extracted by mini-css-extract-plugin
export var activeDot = "_3r-c";
export var buttonContainer = "_3r-9";
export var channelButton = "_3r-a";
export var clickable = "_3r-d";
export var content = "_3r-0";
export var contentFull = "_3r-2";
export var contentThird = "_3r-1";
export var contentWrapper = "_3r-7";
export var description = "_3r-5";
export var heightShort = "_3r-f";
export var image = "_3r-3";
export var imageContainer = "_3r-4";
export var selectButton = "_3r-e";
export var spinnerContainer = "_3r-b";
export var titleContent = "_3r-8";
export var titleWrapper = "_3r-6";